<template lang="pug">
#popup.componente-popup-tooltip(v-if='propriedade && propriedade.codigo')
    div(style='display: flex; justify-content: space-between')
        h4 {{ $t('mensagens.menuMapa.labels.informacoesImovel') }}
        i.mdi.mdi-close.font-weight-bold(
            @click.stop='closePopUp',
            style='cursor: pointer'
        )

    h5(style='margin: 10px 0 10px 0') {{ propriedade.codigo }}

    div
        strong {{ $t('mensagens.menuMapa.labels.situacao') }}:
        span {{ propriedade.situacao }}
    div
        strong {{ $t('mensagens.menuMapa.labels.area') }}:
        span {{ areaFormatada }} ha
    div
        strong {{ $t('mensagens.menuMapa.labels.localidade') }}:
        span {{ propriedade.nome_municipio ? propriedade.nome_municipio : '' }} / {{ propriedade.uf }}

    .btn-adicionar-container
        el-button.colorButton(
            type='success',
            icon='el-icon-plus',
            size='small',
            @click.stop='adicionarImovel'
        ) {{ $t('mensagens.menuMapa.labels.adicionar') }}
</template>
<script>
import EventBus from '@/utils/eventBus';

export default {
    name: 'PopupCarSelecionadoNoMapa',
    data() {
        return {
            propriedade: {}
        };
    },
    mounted() {
        EventBus.$on(
            'cadastro-territorio:fechar-modal-car-selecionado',
            this.closePopUp
        );
        EventBus.$on(
            'mapa:atualizar-dados-popup-car-selecionado',
            this.atualizarPropriedades
        );
    },

    methods: {
        atualizarPropriedades(data) {
            this.propriedade = null;
            if (data) {
                this.propriedade = data.properties;
            }
        },

        adicionarImovel() {
            this.$bus.$emit(
                'mapa:adicionar-car-selecionado-tabela',
                this.propriedade.codigo
            );
            this.propriedade = null;
        },
        closePopUp() {
            this.propriedade = null;
            this.$bus.$emit('mapa:limpar-ultima-geometria');
        },
        decodeUtf8(municipioFormater) {
            return decodeURIComponent(escape(municipioFormater));
        },
        skip() {}
    },
    computed: {
        areaFormatada() {
            return this.propriedade.areaHa
                ? this.propriedade.areaHa.toFixed(2)
                : null;
        }
    }
};
</script>
<style lang="scss" scoped>
.componente-popup-tooltip {
    padding: 10px;
    width: 320px;
    background-color: var(--white);
    border-radius: 4px;

    strong {
        margin-right: 4px;
    }

    .btn-adicionar-container {
        margin-top: 10px !important;
        display: flex;
        justify-content: flex-end;
    }
    .btn-adicionar-container i {
        margin-right: 0px !important;
    }
    .btn-adicionar-container button {
        width: 100px !important;
    }
}

.colorButton {
    background-color: #67c23a;
    color: var(--white);
}

.colorButton:hover {
    background-color: #85ce61;
    color: var(--white);
}

.leaflet-touch .leaflet-bar button {
    line-height: 16px;
}

.fontButton {
    line-height: 16px;
}
</style>
